import { render, staticRenderFns } from "./EditFakeTeam.vue?vue&type=template&id=464faae1&scoped=true"
import script from "./EditFakeTeam.vue?vue&type=script&lang=js"
export * from "./EditFakeTeam.vue?vue&type=script&lang=js"
import style0 from "./EditFakeTeam.vue?vue&type=style&index=0&id=464faae1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464faae1",
  null
  
)

export default component.exports